import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarContent } from './Sidebar';

// Replaces the stock app sidebar. The sidebar content is authored explicitly
// and ignores the `items` the blueprint offers (page-provided nav items), so
// the entries, their order and their feature flags stay as they were.
export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    NavContentBlueprint.make({
      params: { component: SidebarContent },
    }),
  ],
});
